import { ASSET_PATHS } from '../../utils/assetPath';

import './SuccessIcon.css';

interface SuccessIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * SuccessIcon component
 *
 * Displays a success checkmark icon using the SVG from the public folder.
 * Used primarily to indicate completed sections or successful states throughout the application.
 *
 * @example
 * <SuccessIcon />
 * <SuccessIcon size={32} ariaLabel="Section completed" />
 */
function SuccessIcon({ className = '', size = 32, ariaLabel = 'Success' }: SuccessIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`success-icon ${className}`}
      height={size}
      src={ASSET_PATHS.SUCCESS_ICON}
      width={size}
    />
  );
}

export default SuccessIcon;
